module.exports = __webpack_public_path__ + "static/img/SISG.27f227b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/SISG.jpg
// module id = abWH
// module chunks = 0